import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

export default function FormDialog(props) {
  const { InstanceID, name, status } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const Delete = (InstanceID) => (e) => {
    e.preventDefault();
    window.location.reload();
    fetch(
      `${process.env.REACT_APP_API_URL}/api/manageInstance/${InstanceID}/`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        handleClose();
      })
      .catch((error) => {
        handleClose();
      });
    handleClose();
  };

  return (
    <div>
      {status === "Running" ||
      status === "Stopped" ||
      status === "Scheduled" ||
      status === "Cordoned" ? (
        <React.Fragment>
          <MenuItem onClick={handleClickOpen}>
            <IconButton aria-label="delete">
              <DeleteIcon /> &nbsp;&nbsp;
              <span style={{ fontSize: "0.7em", color: "#172B4D" }}>
                Delete
              </span>
            </IconButton>
          </MenuItem>
        </React.Fragment>
      ) : (
        ""
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title"></DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the Lab{" "}
            <strong style={{ color: "#EF5350" }}>{name}</strong> ?
          </DialogContentText>
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={Delete(InstanceID)} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
